import React, { Component } from 'react';
import { Form, Screen } from 'dooh-react-utils';
import styled, { ThemeProvider } from 'styled-components';
import { TERMS } from '../terms';

const FIELDS = [
  {name: 'name', label: 'Ime i prezime', type: 'name'},
  {name: 'email', label: 'E-mail', type: 'email'},
  {name: 'birth', label: 'Datum rođenja', type: 'birth'},
];

const THEME = {
  buttonBackgroundColor: '#005a9c',
  buttonTextColor: 'white',
  keyboardBackgroundColor: '#005a9c',
  keyboardTextColor: 'white',
};

const Wrapper = styled.div`
  padding-top: 200px;
`;

const DISCLAIMER = `* Pristajem na korištenje prikupljenih podataka
i da me se kontaktira vezano za ugovaranje proizvoda Zagrebačke banke.`;

export default class FormScreen extends Component {
  render() {
    return (
      <Screen>
        <ThemeProvider theme={THEME}>
          <Wrapper>
            <Form
              fields={FIELDS}
              onSubmit={this.handleSubmit}
              terms={TERMS}
              disclaimer={DISCLAIMER}
            />
          </Wrapper>
        </ThemeProvider>
      </Screen>
    );
  }

  handleSubmit = data => {
    data.birth = data.birth.replace(/^(\d{2})(\d{2})(\d{4})$/, '$3-$2-$1');
    window.track('submit', Object.assign({id: this.props.session}, this.props.game, data), true);
    this.props.gotoNextScreen();
  }
}



// WEBPACK FOOTER //
// ./src/screens/FormScreen.js